import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { ContratoDetail } from '../types/types'
import { contratosRepository } from './contratosRepository'

export const useContrato = makeUseFetchOne<ContratoDetail, string>({
  fetch: contratosRepository.fetchOne
})
